import { useContext } from "react";

import type { LoginMethod } from "@shared/components/LoginOptions/types/LoginMethod";
import { useFlippers } from "@shared/context/FlippersContext";
import { GlobalContext } from "@shared/context/GlobalConfig";

const useLastUsedLoginMethod = (): LoginMethod | null => {
  const [isLastUsedFlipperEnabled] = useFlippers("titan_last_login_used");
  const { lastUsedLoginMethod } = useContext(GlobalContext);

  if (!isLastUsedFlipperEnabled) return null;

  return lastUsedLoginMethod ?? null;
};

export { useLastUsedLoginMethod };
